import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { AccessRequestClientModel, useRequestAgainAccessRequest } from '@client-app-sdk';
import { LoadingButton } from '@mui/lab';
import { ConfirmDialogWithInput } from '@common/ui/ConfirmDialog';
import { useNavigate } from 'react-router-dom';
import routes from '@routes';
import { Typography } from '@mui/material';
import { AnalyticsEvents } from '@common/utils/analytics/events';

export default function RequestAgain({
  request,
  buttonText,
}: {
  request: AccessRequestClientModel;
  buttonText?: string;
}) {
  const { requestAgainAccessRequest, isLoading, isSuccess } = useRequestAgainAccessRequest(request.id);
  const [opened, setOpened] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess) {
      toast.success(`Request ${request.id} requested again`);
      navigate(routes.OpenRequests.path);
    }
  }, [isSuccess, navigate, request.id]);

  return (
    <>
      <LoadingButton
        data-trigger={AnalyticsEvents.RequestAgainClicked}
        data-props={JSON.stringify({ requestId: request.id })}
        variant="outlined"
        size="small"
        onClick={() => setOpened(true)}
        loading={isLoading}
      >
        {buttonText || 'Request again'}
      </LoadingButton>
      <ConfirmDialogWithInput
        open={opened}
        inputProps={{
          label: 'Justification',
          multiline: true,
          maxRows: 2,
        }}
        onClose={() => setOpened(false)}
        onConfirm={(justification) => requestAgainAccessRequest({ justification })}
        confirmLabel="Submit"
        disproveLabel="Cancel"
      >
        <Typography variant="body2">You will resubmit the same access request for approval.</Typography>
      </ConfirmDialogWithInput>
    </>
  );
}
